import { Component, Host, State, h } from '@stencil/core';

@Component({
  tag: 'nest-theme-switcher',
  styleUrl: './nest-theme-switcher.scss',
  shadow: false,
})
export class NestThemeSwitcher {
  private readonly themeKey = 'nest-theme';

  @State() isDarkMode: boolean = JSON.parse(localStorage.getItem(this.themeKey) || 'false') || false;

  constructor() {
    this.setThemeAttribute();
  }

  handleChangeTheme = () => {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem(this.themeKey, JSON.stringify(this.isDarkMode));
    this.setThemeAttribute();
  }

  setThemeAttribute = () => {
    this.isDarkMode
      ? document.querySelector('html').setAttribute('data-theme', 'dark')
      : document.querySelector('html').removeAttribute('data-theme');
  }

  render() {
    const { isDarkMode } = this;
    return (
      <Host class='nest-theme-switcher' onClick={this.handleChangeTheme}>
          {isDarkMode
            ? (<nest-icon name='dark-theme' class='w-5 h-5'></nest-icon>)
            : (<nest-icon name='light-theme' class='w-5 h-5'></nest-icon>)
          }

      </Host>
    );
  }
}
